import { render, staticRenderFns } from "./MantraList.vue?vue&type=template&id=0c101050&scoped=true&"
import script from "./MantraList.vue?vue&type=script&lang=js&"
export * from "./MantraList.vue?vue&type=script&lang=js&"
import style0 from "./MantraList.vue?vue&type=style&index=0&id=0c101050&lang=scss&scoped=true&"
import style1 from "./MantraList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c101050",
  null
  
)

export default component.exports